import { GalleryManageComponent } from './gallery-manage/gallery-manage.component';
import { GalleriesComponent } from './galleries/galleries.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PagesComponent } from './pages/pages.component';
import { AuthGuard } from '../guards/auth-guard';
import { MenusComponent } from './menus/menus.component';
import { PageComponent } from './page/page.component';
import { FaqTopicsComponent } from '../faq/faq-topics/faq-topics.component';
import { FaqQuestionsComponent } from '../faq/faq-questions/faq-questions.component';
import { SpacesComponent } from '../spaces/spaces.component';
import { UserPhotoSubmissionsComponent } from './user-photo-submissions/user-photo-submissions.component';

const routes: Routes = [
    {
        path: 'pages',
        component: PagesComponent,
        canActivate: [AuthGuard],
        data: {
            menuGroup: ['cms'],
            colouredBackground: true,
            offset: true,
            showMenu: true,
            showHeader: true,
            showFooter: true,
            disableAuthTimeout: false,
        },
    },

    {
        path: 'galleries',
        component: GalleriesComponent,
        canActivate: [AuthGuard],
        data: {
            menuGroup: ['cms'],
            colouredBackground: true,
            offset: true,
            showMenu: true,
            showHeader: true,
            showFooter: true,
            disableAuthTimeout: false,
        },
    },
    {
        path: 'galleries/:id',
        canActivate: [AuthGuard],
        component: GalleryManageComponent,
        pathMatch: 'full',
        data: {
            menuGroup: ['cms'],
            staticRoute: '/cms/galleries',
        },
    },
    {
        path: 'menus',
        canActivate: [AuthGuard],
        component: MenusComponent,
        pathMatch: 'full',
        data: {
            menuGroup: ['cms'],
        },
    },
    {
        path: 'pages/:route',
        canActivate: [AuthGuard],
        component: PageComponent,
        pathMatch: 'full',
        data: {
            menuGroup: ['cms'],
            staticRoute: '/cms/pages',
        },
    },
    {
        path: 'faq',
        canActivate: [AuthGuard],
        component: FaqTopicsComponent,
        pathMatch: 'full',
        data: {
            menuGroup: ['cms'],
        },
    },
    {
        path: 'faq/:topic',
        canActivate: [AuthGuard],
        component: FaqQuestionsComponent,
        pathMatch: 'full',
        data: {
            menuGroup: ['cms'],
            staticRoute: '/cms/faq',
        },
    },
    {
        path: 'user-photo-submissions',
        component: UserPhotoSubmissionsComponent,
        canActivate: [AuthGuard],
        data: {
            menuGroup: ['cms'],
            colouredBackground: true,
            offset: true,
            showMenu: true,
            showHeader: true,
            showFooter: true,
            disableAuthTimeout: false,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CmsRoutingModule {}
